import React, { useState, useEffect, useRef, useCallback } from "react";
import { Badge, Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import moment from "moment";
import WhatsAppChat from "../whatsapp_messenger/WhatsAppChat";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { FaArrowUp, FaUsers } from "react-icons/fa";

const LeadView = ({ socket, selectedWhatsAppSetting }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [lead, setLead] = useState(location.state || {});
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(!location.state);
  const [allOwners, setAllOwners] = useState([]);
  const [userInfo, setUserInfo] = useState(
    jwt_decode(sessionStorage.getItem("token")),
  );

  const leadTopAnchorRef = useRef(null);
  const scrollParentRef = useRef(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  /** App layout scrolls `.outlet-container`, not `window` (body is overflow:hidden). */
  useEffect(() => {
    const el =
      document.querySelector("#content .outlet-container") ||
      document.querySelector(".outlet-container");
    scrollParentRef.current = el;
    if (!el) return;

    const onScroll = () => setShowScrollTop(el.scrollTop > 200);
    el.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToLeadDetails = () => {
    leadTopAnchorRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const formatPhoneNumber = (number) => {
    const shouldHideNumber =
      userInfo?.userrole === "USER" &&
      userInfo?.is_whatsapp_number_hidden === true;

    if (shouldHideNumber && number) {
      const numberString = String(number);
      if (numberString.length <= 5) return numberString;
      const visibleDigits = numberString.slice(-5);
      const maskedDigits = "X".repeat(numberString.length - 5);
      return `${maskedDigits}${visibleDigits}`;
    }
    return number;
  };

  useEffect(() => {
    // Only fetch if we don't have the data in location.state
    if (id) {
      fetchLead();
    }
  }, [id, selectedWhatsAppSetting]);

  // Extract all owners from lead data
  useEffect(() => {
    if (lead && lead.all_owner_names) {
      setAllOwners(lead.all_owner_names || []);
    } else if (lead && lead.ownerid) {
      // If no all_owner_names but we have ownerid, create a basic array
      setAllOwners([{ id: lead.ownerid, name: lead.ownername }]);
    } else {
      setAllOwners([]);
    }
  }, [lead]);

  const fetchLead = async () => {
    try {
      setIsLoading(true);
      const result = await WhatsAppAPI.fetchLeadById(id);
      if (result.success) {
        // Add formatted phone number to the lead data
        const formattedLead = {
          ...result.records,
          display_whatsapp_number: formatPhoneNumber(
            result.records.whatsapp_number,
          ),
        };
        setLead(formattedLead);

        // If no all_owner_names in response but we have ownerids, fetch them
        if (
          !formattedLead.all_owner_names &&
          formattedLead.ownerids &&
          formattedLead.ownerids.length > 0
        ) {
          try {
            const ownersResult = await WhatsAppAPI.fetchUsersByIds(
              formattedLead.ownerids,
            );
            if (ownersResult.success) {
              formattedLead.all_owner_names = ownersResult.records.map(
                (user) => ({
                  id: user.id,
                  name:
                    `${user.firstname || ""} ${user.lastname || ""}`.trim() ||
                    user.username,
                }),
              );
              setLead(formattedLead);
            }
          } catch (ownerError) {
            console.error("Error fetching owner details:", ownerError);
          }
        }
      } else {
        toast.error("Failed to fetch lead details");
        navigate("/leads");
      }
    } catch (error) {
      console.error("Error fetching lead:", error);
      toast.error("Error loading lead details");
      navigate("/leads");
    } finally {
      setIsLoading(false);
    }
  };

  const deleteLead = async () => {
    try {
      const result = await WhatsAppAPI.deleteLead(lead.id);
      if (result.success) {
        toast.success("Lead deleted successfully");
        navigate("/leads");
      } else {
        toast.error(result.message || "Failed to delete lead");
      }
    } catch (error) {
      console.error("Error deleting lead:", error);
      toast.error("Error deleting lead");
    }
  };

  const editLead = (lead) => {
    navigate(`/leads/${lead.id}/e`, { state: lead });
  };

  const handleBack = () => {
    navigate("/leads");
  };

  if (isLoading) {
    return (
      <div className="app-view-page">
        <Container fluid className="px-0">
          <Row>
            <Col className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading lead details...</p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="app-view-page">
      {/* <Container className="mt-5">
        <Row className="mx-5 section-header">
          <Col lg={12} sm={12} xs={12}>
            <Row className="view-form-header align-items-center">
              <Col lg={8} sm={8} xs={8} className="text-capitalize">
                Lead
                <h5>
                  {lead.firstname ? lead.firstname + " " : ""}
                  {lead.lastname || ""}
                </h5>
              </Col>
              <Col lg={4} sm={4} xs={4} className="text-end">
                <Button
                  className="mx-2 btn-sm"
                  variant="outline-light"
                  onClick={handleBack}
                >
                  Back
                </Button>
                {!(
                  userInfo?.userrole === "USER" &&
                  userInfo?.is_whatsapp_number_hidden === true
                ) && (
                  <Button
                    className="mx-2 btn-sm"
                    variant="light"
                    onClick={() => editLead(lead)}
                  >
                    Edit
                  </Button>
                )}

                <Button
                  className="btn-sm mx-2"
                  variant="danger"
                  onClick={() => setModalShow(true)}
                >
                  Delete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container> */}
      <div ref={leadTopAnchorRef} className="lead-header">
        <div>
          <p className="lead-label">Lead</p>
          <h3 className="lead-title">
            {lead.firstname} {lead.lastname}
          </h3>
        </div>

        <div className="lead-actions">
          <Button className="btn-back btn-sm" onClick={handleBack}>
            Back
          </Button>

          {!(
            userInfo?.userrole === "USER" &&
            userInfo?.is_whatsapp_number_hidden === true
          ) && (
            <Button className="btn-edit btn-sm" onClick={() => editLead(lead)}>
              Edit
            </Button>
          )}

          <Button
            className="btn-delete btn-sm"
            onClick={() => setModalShow(true)}
          >
            Delete
          </Button>
        </div>
      </div>

      <div className="lead-card mt-3">
        <div className="lead-grid">
          <div className="field">
            <label>Lead Name</label>
            <p>
              {lead.firstname || lead.lastname
                ? `${lead.firstname || ""} ${lead.lastname || ""}`
                : "-"}
            </p>
          </div>

          <div className="field">
            <label>WhatsApp Number</label>
            <p>
              {lead.whatsapp_number
                ? `${lead.country_code}${
                    lead.display_whatsapp_number ||
                    formatPhoneNumber(lead.whatsapp_number)
                  }`
                : "-"}
            </p>
          </div>

          <div className="field">
            <label>Email</label>
            <p>{lead.email || "-"}</p>
          </div>

          <div className="field">
            <label>Lead Source</label>
            <p>{lead.leadsource || "-"}</p>
          </div>

          <div className="field">
            <label>Status</label>
            <span className="status-badge">{lead.leadstatus || "N/A"}</span>
          </div>

          <div className="field">
            <label>Date of Birth</label>
            <p>{lead.dob ? moment(lead.dob).format("DD MMM, YYYY") : "-"}</p>
          </div>

          <div className="field">
            <label>Address</label>
            <p>{lead.address || "-"}</p>
          </div>

          <div className="field">
            <label>Description</label>
            <p>{lead.description || "-"}</p>
          </div>

          <div className="field">
            <label>Tags</label>
            <div className="tags">
              {lead.tag_names?.length > 0
                ? lead.tag_names.map((tag, i) => (
                    <span key={i} className="tag">
                      {tag.name}
                    </span>
                  ))
                : "-"}
            </div>
          </div>

          <div className="field">
            <label>Owners</label>
            <div className="owners mt-2">
              {allOwners.map((owner, i) => (
                <span key={i} className="owner">
                  {owner.name}
                </span>
              ))}
            </div>
          </div>

          <div className="field">
            <label>Created</label>
            <p>
              {lead.createddate
                ? moment(lead.createddate).format("DD MMM, YYYY")
                : "-"}
            </p>
          </div>

          <div className="field">
            <label>Last Modified</label>
            <p>
              {lead.lastmodifieddate
                ? moment(lead.lastmodifieddate).format("DD MMM, YYYY")
                : "-"}
            </p>
          </div>
        </div>
      </div>

      {lead && lead.id && lead.whatsapp_number && (
        <Container fluid className="px-0 mb-5 mt-4">
          <Row className="g-0">
            <Col lg={12} sm={12} xs={12} className="mb-4">
              <WhatsAppChat
                userDetail={lead}
                socket={socket}
                selectedWhatsAppSetting={selectedWhatsAppSetting}
              />
            </Col>
          </Row>
        </Container>
      )}

      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteLead={deleteLead}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="lead"
        />
      )}

      {showScrollTop && (
        <Button
          type="button"
          variant="success"
          className="lead-view-scroll-top"
          onClick={scrollToLeadDetails}
          aria-label="Scroll to lead details"
          title="Back to lead details"
        >
          <FaArrowUp aria-hidden />
        </Button>
      )}

      <ToastContainer />
    </div>
  );
};

export default LeadView;
